export default __webpack_public_path__ + "static/media/LynkcoType-Light.c0a5ad18.ttf";